import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IPatchStatusModel, IService } from '../../../models';
import { serviceResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

const usePatchRequest = () => {
  async function callPatchApi(url: string, patchStatusData: IPatchStatusModel) {
    const resp = await apiWrapper.patch<IService, { errorMessage: string }>(
      url,
      patchStatusData,
      headersInstance()
    );

    const apiResponse = serviceResponseSchema.validate(resp.responseBody, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse?.value) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const serviceRecords = resp.responseBody;
    return {
      serviceRecords,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const changeServiceStatus = (url: string, patchStatusData: IPatchStatusModel) => callPatchApi(url, patchStatusData);

  return { changeServiceStatus };
};

export default usePatchRequest;
